<template>
    <div>
        <div v-show="!saveOrUpdate.visible&&!look.visible&&!saveChecks.visible&&!printCheck.visible">
            <!--搜索表单-->
            <div class="search-box">
                <el-form ref="searchForm" :rules="rules"  :inline="true" :model="searchForm" >
                    <el-form-item label="关键词:" prop="keyWord">
                        <el-input size="mini" v-model="searchForm.keyWord" placeholder="请输入客户姓名"></el-input>
                    </el-form-item>
                     <el-form-item label="入住店面:" prop="hotelId">
                         <el-select size="mini" filterable v-model="searchForm.hotelId" placeholder="请选择入住店面">
                             <el-option v-for="item in hotelList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                         </el-select>
                     </el-form-item>
                    <el-form-item label="认领状态:" prop="status">
                        <el-select size="mini" filterable v-model="searchForm.status" placeholder="请选择认领状态">
                            <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="提交时间" prop="times">
                        <el-date-picker size="mini" v-model="searchForm.times" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysHotelCheck-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh-left" plain @click="clear">清空</el-button>
                        <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysHotelCheck-save icon="el-icon-plus" @click="toSaveOrUpdate" >新增</el-button>
                        <el-dropdown>
                            <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-display:sysHotelCheck-batchUpdate icon="el-icon-edit" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-export icon="el-icon-download" @click.native="exportSysHotelCheck">导出</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-exportField icon="el-icon-download" @click.native="exportSysHotelCheckDialog">导出选择字段</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>
                </el-form>
             </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true" :data="tableData" @selection-change="changeFun"   @sort-change="sortChange" >
                <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column show-overflow-tooltip prop="names" label="客户姓名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="phones" label="电话"></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCards" label="身份证号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="hotelName" label="入住店面"></el-table-column>
                <el-table-column show-overflow-tooltip prop="houseName" label="入住房号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="提交时间" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="认领状态">
                    <template slot-scope="scope">
                        <span :style="{'color':statusColorMap[scope.row.status]}">{{statusMap[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="claimAdminName" label="认领操作人"></el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="认领备注"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80"  >
                    <template slot-scope="scope">
                        <el-dropdown>
                            <span class="el-dropdown-link" style="color: #409EFF">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-display:sysHotelCheck-update @click.native="toSaveOrUpdate($event,scope.row.id)">修改</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-look @click.native="toLook($event,scope.row.id)">查看</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-delete  @click.native="deleteData(scope.row.id)">删除</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-saveCheck v-if="scope.row.status=='0'" @click.native="toSaveOrUpdates($event,scope.row.id,scope.row.agreementId)">认领</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-saveCheck v-else disabled>认领</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-upCheck v-if="scope.row.status==1" @click.native="updateStatus(scope.row.id,0)">退回</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-upCheck v-else disabled>退回</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-print v-if="scope.row.status==1" @click.native="toPrintChecks(scope.row.id,scope.row.agreementId)">打印</el-dropdown-item>
                                <el-dropdown-item v-display:sysHotelCheck-print v-else disabled>打印</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <el-pagination
                    style="margin-top: 10px;padding-bottom: 20px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.pager.totalCount"
                    :page-size="searchForm.pager.pageSize"
                    :current-page.sync="searchForm.pager.page"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
            ></el-pagination>
        </div>
        <!--批量修改-->
        <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="900px" :visible.sync="batchDialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                <el-form-item label="店面编号" prop="hotelId">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.hotelId" placeholder="请输入店面编号" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--选择字段导出-->
        <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
            <div style="height: 400px;overflow-y: auto;width: 100%" >
                <!--表格-->
                <el-table border size="mini"  :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                    <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                    <el-table-column prop="key" label="英文字段名" ></el-table-column>
                    <el-table-column prop="name" label="中文字段名" ></el-table-column>
                    <el-table-column prop="newName" label="重命名字段" >
                        <template slot-scope="scope">
                            <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysHotelCheckByField">确认导出</el-button>
            </div>
        </el-dialog>
        <save-or-update-sys-hotel-check v-if="saveOrUpdate.visible" v-bind="saveOrUpdate" @closeSaveOrUpdate="closeSaveOrUpdate"></save-or-update-sys-hotel-check>
        <look-sys-hotel-check v-if="look.visible" v-bind="look" :visible.sync="look.visible"></look-sys-hotel-check>
        <save-or-update-sys-hotel-checks v-if="saveChecks.visible" v-bind="saveChecks" @closeSaveChecks="closeSaveChecks"></save-or-update-sys-hotel-checks>
        <print-sys-hotel-checks v-if="printCheck.visible" v-bind="printCheck" @closePrintCheck="closePrintCheck"></print-sys-hotel-checks>

    </div>
</template>

<script>
    import axios from 'axios';
    import saveOrUpdateSysHotelCheck from './saveOrUpdateSysHotelCheck';
    import saveOrUpdateSysHotelChecks from './saveOrUpdateSysHotelChecks';
    import lookSysHotelCheck from './lookSysHotelCheck';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import printSysHotelChecks from './printSysHotelChecks';
    export default {
        name: "sysHotelCheck",
        components:{saveOrUpdateSysHotelCheck,lookSysHotelCheck,noData,saveOrUpdateSysHotelChecks,printSysHotelChecks},
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                searchForm:{
                    adminId: '',
                    adminName: '',
                    agreementId: '',
                    hotelId: '',
                    hotelName: '',
                    houseName: '',
                    names: '',
                    phones: '',
                    idCards: '',
                    userAgent: '',
                    browser: '',
                    os: '',
                    status: '',
                    startTime: '',
                    endTime: '',
                    days: '',
                    writeName: '',
                    claimTime: '',
                    claimAdminId: '',
                    claimAdminName: '',
                    updateTime: '',
                    createTime: '',
                    statusArry:['0','1'],
                    times:[],
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:20,
                        totalCount:0,
                        like:'names,idCards,phones,houseName',
                        keyWordField:'names,idCards,phones,houseName,claimAdminName,hotelName',
                    }
                },
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    hotelId:'',
                    hotelName:'',
                    houseName:'',
                    name:'',
                    idCard:'',
                    phone:'',
                    idCardFrontImg:'',
                    idCardReverseImg:'',
                    healthCodeImg:'',
                    runCodeImg:'',
                    userAgent:'',
                    browser:'',
                    os:'',
                    status:'',
                    startTime:'',
                    endTime:'',
                    days:'',
                    updateTime:'',
                    createTime:''
                },
                tableData: [],
                saveOrUpdate:{
                    visible:false,
                    title:'增加',
                    id:''
                },
                saveChecks:{
                    visible:false,
                    title:'认领',
                    id:'',
                    agreementId:'',
                },
                look:{
                    visible:false,
                    id:''
                },
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysHotelCheck/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                rules: {
                    adminId: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    adminName: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    hotelId: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    hotelName: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    houseName: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    name: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    idCard: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    phone: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    idCardFrontImg: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    idCardReverseImg: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    healthCodeImg: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    runCodeImg: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    userAgent: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    browser: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    os: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    status: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    startTime: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    endTime: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    days: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    updateTime: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    createTime: [
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                batchDialog:{
                   dialogFormVisible:false,
                   title:'批量修改'
                },
                statusMap:["已登记(待认领)","已认领","已归档"],
                statusColorMap:["#000","#f5ba2b","#49f729","#4b9cff"],
                config:config,
                hotelList:[],
                statusList:[
                    {
                        value:'0',
                        name:'已登记(待认领)',
                    },
                    {
                        value:'1',
                        name:'已认领',
                    },
                ],
                printCheck:{
                    visible:false,
                    title:'打印',
                    id:'',
                    agreementId:'',
                },
            }
        },
        created(){
            this.findHotelList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            findHotelList(){
                axios({
                    url: `${home}/sysDdList/findHotelListByCondition`,
                    method: "GET",
                }).then(res => {
                    this.hotelList = res.data;
                }).catch(error => {
                });
            },
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            toSaveOrUpdate($event,id){
                if(id){
                    this.saveOrUpdate.title='修改';
                    this.saveOrUpdate.id=id;
                }else{
                    this.saveOrUpdate.title='增加';
                }
                this.saveOrUpdate.visible=true;
            },
            closeSaveOrUpdate(data){
                this.saveOrUpdate.visible=false;
                this.submit();
            },
            toSaveOrUpdates($event,id,agreementId){
                if(id){
                    this.saveChecks.title='认领';
                    this.saveChecks.id=id;
                    this.saveChecks.agreementId = agreementId;
                }
                this.saveChecks.visible=true;
            },
            closeSaveChecks(data){
                this.saveChecks.visible=false;
                this.submit();
            },
            toLook($event,id){
                this.look={
                    visible:true,
                    id:id
                }
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysHotelCheck/deleteSysHotelCheck/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })

                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysHotelCheck/findSysHotelChecksByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
                this.searchForm.times = [];
            },
            leadingInSysHotelCheck() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysHotelCheck() {
                if(this.rowData){
                    this.searchForm.rowData= this.rowData;
                }
                axios({
                    url: `${home}/sysHotelCheck/exportSysHotelCheck`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "酒店入住协议登记.xls");
                    this.searchForm.rowData=[];
                });
            },
            exportSysHotelCheckModule() {
                axios({
                    url: `${home}/sysHotelCheck/exportSysHotelCheckModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "酒店入住协议登记模板.xls");
                });

            },
            handleSysHotelCheckSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysHotelCheckUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysHotelCheck/batchDeleteSysHotelCheck`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysHotelCheckDialog(){
                axios({
                    url: `${home}/sysHotelCheck/getSysHotelCheckTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });
            },
            exportSysHotelCheckByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    if(this.rowData){
                        this.searchForm.rowData= this.rowData;
                    }
                    axios({
                        url: `${home}/sysHotelCheck/exportSysHotelCheckByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "酒店入住协议登记.xls");
                        this.exportDialogExcel.dialogFormVisible = false;
                        this.searchForm.rowData=[];
                    });
                }

            },
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/sysHotelCheck/batchUpdateSysHotelCheck`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
            updateStatus(id,status){
                this.$confirm("确认退回吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysHotelCheck/updateSysHotelCheckStatus`,
                        method: "post",
                        data: {
                            id:id,
                            status:status
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "退回成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                });
            },
            toPrintChecks(id,agreementId){
                if(id){
                    this.printCheck.title='打印';
                    this.printCheck.id=id;
                    this.printCheck.agreementId = agreementId;
                }
                this.printCheck.visible=true;
            },
            closePrintCheck(data){
                this.printCheck.visible=false;
                data&&this.submit();
            },
        }
    }
</script>
